import Operation from "../index.js";

export default {
    findWorkPaterNew(params, fn) {
        Operation.Http.post(`/classAway/findWorkPaterNew?classRecordId=${params.classRecordId}&resourceFileId=${params.resourceFileId}`, null, fn)
    },
    submitWorkPaperNew(params, fn) {
        Operation.Http.post(`/classAway/submitWorkPaperNew?classRecordId=${params.classRecordId}`, params.testPaper, fn)
    },

}


// WEBPACK FOOTER //
// ./src/request/api/classAway.js